export class Paginator<T> {
  items: T[];
  total: number;
  totalPages: number;
  currentPage: number;
  perPage: number;

  constructor(pagination: any, items: T[]) {
    this.items = items;
    this.total = pagination.total;
    this.totalPages = pagination.total_pages;
    this.currentPage = pagination.current_page;
    this.perPage = pagination.per_page;
  }

  hasNextPage() {
    return this.currentPage < this.totalPages;
  }

  hasPreviousPage() {
    return this.currentPage > 1;
  }
}



// WEBPACK FOOTER //
// ./src/app/models/paginator.ts